import { required } from 'vee-validate/dist/rules'
import L from 'lodash'

export default {
  ...required,
  validate: (value, params) => {
    // We have to override the implementation to support required on "select" (where itemDTO is set to empty object)
    if (typeof value === 'object' && !L.isDate(value)) {
      return value && Object.keys(value).length > 0 ? { required: true, valid: true } : { required: true, valid: false }
    }
    return required.validate(value, params)
  }
}
